module.exports = __webpack_public_path__ + "img/e2.9dca48cb.png";